import CreatePracticesContext from './CreatePracticesContext'
import createPracticeHooks from './hooks'

export { createPracticeHooks }
export default CreatePracticesContext